import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal, Button, Form, Input } from 'antd';
import AlertMessage from './AlertMessage';
import FormControl from './FormControl';


const ModalCollectEmails = ({
  modalTitle,
  modalIsVisible,
  handdleSendModal,
  handdleCancelModal,
  successButtonText,
  cancelButtonText,
}) => {
  const [errors, setErrors] = useState('');
  const [emails, setEmails] = useState('');

  const emailsAreValid = (textToValidate, setErrorState = false) => {
    if (!textToValidate) {
      if (setErrorState) setErrors('Emails requeridos');
      return false;
    }
    
    const arrayEmails = textToValidate.split(' ');
    const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const invalidEmails = arrayEmails.filter((item) => !emailRegex.test(item));

    if (setErrorState && invalidEmails.length) setErrors('Por favor ingrese emails válidos');

    return !invalidEmails.length;
  };

  const handdleClickOkButton = () => {
    if (!emailsAreValid(emails, true)) return;

    const emailsArray = emails.split(' ');
    handdleSendModal(emailsArray);
  };
  
  const handleChangeEmails = (e) => {
    setEmails(e.target.value);
    setErrors('');
  };

  return (
    <Modal
      title={<h3 style={{ textAlign: 'center' }}>{modalTitle}</h3>}
      visible={modalIsVisible}
      onCancel={handdleCancelModal}
      footer={[
        <Button key="confirm-button-modal" onClick={handdleCancelModal}>{cancelButtonText}</Button>,
        <Button key="cancel-button-modal" type="primary" onClick={handdleClickOkButton}>{successButtonText}</Button>,
      ]}
    >
      <FormControl
        type="text"
        placeholder="Email"
        label="Por favor ingrese los emails válidos"
        onChange={handleChangeEmails}
        value={emails}
      />
      {errors && (
        <AlertMessage title={errors} />
      )}
    </Modal>
  );
};

ModalCollectEmails.defaultProps = {
  modalIsVisible: false,
  handdleSendModal: () => { },
  handdleCancelModal: () => {},
  successButtonText: 'Ok',
  cancelButtonText: 'Cancelar',
};

ModalCollectEmails.propTypes = {
  modalTitle: PropTypes.string.isRequired,
  modalIsVisible: PropTypes.bool,
  handdleSendModal: PropTypes.func,
  handdleCancelModal: PropTypes.func,
  successButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};

export default ModalCollectEmails;
